export const banners = [
  {
    movieId: 1,
    tagline: "远征星海，寻找人类最后的家园",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20space%20scene%20of%20a%20lone%20starship%20drifting%20past%20a%20giant%20glowing%20amber%20nebula%2C%20deep%20teal%20cosmos%20with%20golden%20starlight%2C%20epic%20dramatic%20sci-fi%20atmosphere%2C%20high%20detail%20background%2C%20no%20text&width=1920&height=800&seq=xg-hero-1&orientation=landscape",
  },
  {
    movieId: 11,
    tagline: "渡口初遇，一场关于守护的漫长约定",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20ancient%20chinese%20palace%20terrace%20at%20golden%20sunset%20with%20lanterns%20and%20flowing%20silk%20drapes%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20grand%20historical%20atmosphere%2C%20high%20detail%20background%2C%20no%20text&width=1920&height=800&seq=xg-hero-2&orientation=landscape",
  },
  {
    movieId: 14,
    tagline: "每一条线索，都指向十五年前的旧案",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20dim%20detective%20office%20with%20a%20clue%20board%20of%20photos%20and%20red%20threads%2C%20cold%20slate%20and%20faint%20amber%20light%20rays%2C%20tense%20noir%20atmosphere%2C%20high%20detail%20background%2C%20no%20text&width=1920&height=800&seq=xg-hero-3&orientation=landscape",
  },
  {
    movieId: 20,
    tagline: "用每一次演出，重新定义舞台",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20concert%20stage%20with%20glowing%20spotlights%20and%20crowd%20silhouettes%2C%20deep%20stage%20purple%20and%20warm%20gold%20highlights%2C%20electric%20passionate%20atmosphere%2C%20high%20detail%20background%2C%20no%20text&width=1920&height=800&seq=xg-hero-4&orientation=landscape",
  },
  {
    movieId: 3,
    tagline: "踏入秘境，见证东方奇幻的壮阔想象",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20misty%20ancient%20mountains%20with%20floating%20islands%20at%20golden%20sunrise%2C%20lush%20green%20and%20warm%20gold%20palette%2C%20epic%20oriental%20fantasy%20atmosphere%2C%20high%20detail%20background%2C%20no%20text&width=1920&height=800&seq=xg-hero-5&orientation=landscape",
  },
];